/**
 * Pure helpers for the DataTable filter-value object. Kept out of the
 * overlay component file so React Fast Refresh stays happy (a module
 * that exports components should export only components).
 *
 * A filter-values object is keyed by filter `key`; the shape per entry
 * depends on the filter `type`:
 *   checkbox  → string[]        (selected values)
 *   radio     → string          ('' = none)
 *   select    → string          ('' = none)
 *   daterange → { from, to }    (ISO date strings)
 *   text      → string
 */

/** Blank values object for a filter config. */
export function emptyFilterValues(config) {
  const v = {}
  for (const f of config || []) {
    if (f.type === 'checkbox') v[f.key] = []
    else if (f.type === 'daterange') v[f.key] = { from: '', to: '' }
    else v[f.key] = '' // radio / select / text
  }
  return v
}

/** Count how many filter groups are active in a values object. */
export function countFilters(config, values) {
  let n = 0
  for (const f of config || []) {
    const v = values?.[f.key]
    if (f.type === 'checkbox') n += Array.isArray(v) && v.length ? 1 : 0
    else if (f.type === 'daterange') n += v && (v.from || v.to) ? 1 : 0
    else n += v ? 1 : 0 // radio / select / text
  }
  return n
}
